import { Component, OnInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { SupportService } from '../../services/support.service';
import { v4 as uuidv4 } from 'uuid';
import { ChatBotRequest } from '../../models/chatbot-request';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { parseJSON } from 'date-fns';

@Component({
    selector: 'or-chatbot',
    templateUrl: './chatbot.component.html',
    styleUrls: ['./chatbot.component.scss'],
    standalone: false
})
export class ChatbotComponent implements OnInit {
  constructor(public supportService: SupportService, private ngZone: NgZone, private sanitizer: DomSanitizer) {  }

  @ViewChild('chatBox') chatBox: any;
  @ViewChild('textArea') textArea: ElementRef<HTMLTextAreaElement>;
  messages: { text: string, type: string, doneProcessing: boolean}[] = [];
  userMessage: string = '';
  showChat = false;
  isOverflowing = false;
  waitingForResponse = false;
  sessionId = null;
  nextQuestions = [];
  sourceURLs: string[] = [];
  extrasFromResponse = '';
  stream = false;
  rowCount = 1;
  chatBoxHeight = 138;
  minRows: number = 1; // Set your minimum row count
  isProcessingChunk = false;
  addedEventListener = false;
  chunkQueue: string[] = [];

  ngOnInit(): void {
  }

  addEventListenerToChatBox() {
    const chatDiv = this.chatBox.nativeElement;
    chatDiv.addEventListener('click', (e: MouseEvent) => {
      const target = (e.target as HTMLElement).closest('a');
      if (target && chatDiv.contains(target)) {
        window.open((target as HTMLAnchorElement).href, '_blank');
        e.preventDefault(); // prevent same-tab navigation
      }
    });
  }
  sendMessage(text = null) {
    if (this.addedEventListener == false) {
      this.addEventListenerToChatBox();
      this.addedEventListener = true;
    }
    if (text == null)
    {
      text = this.userMessage;
    }    
    text = text.trim();
    if (text === '' || this.waitingForResponse) return;

    this.waitingForResponse = true;
    this.nextQuestions = [];
    this.extrasFromResponse = '';
    this.messages.push({text: text, type: 'user', doneProcessing: true});
    var index = this.messages.length;

    this.checkForYOverflow();
    try {
      const clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;      
      var request : ChatBotRequest = {
        requestText: text,
        sessionId: this.sessionId,
        clientTimeZone: clientTimeZone
      }

      this.supportService.streamMessage(request, (chunk) => {

        chunk = chunk.replace(/\\'/g, "'");
        const alreadyBlockedRegex = String.raw`</?(?:p|ul|ol|li|div|h[1-6]|blockquote|table|thead|tbody|tr|td|hr)\b[^>]*>`;

        // Extract 'answer' string
        let answerMatch = chunk.match(/{"answer":\s*(['"`])([\s\S]*?)\1,\s*"footerUrls"/);
        // console.log('Answer match:', answerMatch);
        let answer = answerMatch ? answerMatch[2] : '';
        answer = answer.replace(new RegExp(String.raw`(?:\s*\\n\s*)+(?=${alreadyBlockedRegex})`, "g"), "").replace(new RegExp(String.raw`(${alreadyBlockedRegex})(?:\s*\\n\s*)+`, "g"), "$1").replace(/:\\n\\n/g, "<br>").replace(/\\n/g, "<br>");
        // fix zoho links that were made relative
        answer = answer.replace(
          /href="\/portal\/en\/kb([^"]*)"/g,
          'href="https://opinionroute.zohodesk.com/portal/en/kb$1"'
        );
        // Extract 'footerURLs' array
        const footerMatch = chunk.match(/"footerUrls":\s*\[([\s\S]*?)\],\s*"userPrompts"/);
        let footerURLs: string[] = [];
        if (footerMatch) {
          footerURLs = footerMatch[1]
            .split(',')
            .map(s => s.trim().replace(/^"|"$/g, ''))
            .filter(s => s.length > 0);
        }
        this.sourceURLs = footerURLs;

        // Extract 'userPrompts' array
        const promptsMatch = chunk.match(/"userPrompts":\s*\[([\s\S]*?)\]\s*}/);
        let userPrompts: string[] = [];
        if (promptsMatch) {
          userPrompts = promptsMatch[1]
            .split(',')
            .map(s => s.trim().replace(/^"|"$/g, ''))
            .filter(s => s.length > 0);
        }
        this.nextQuestions = userPrompts;
        if (chunk.length <= 0) return;

        this.ngZone.run(() => {
          this.waitingForResponse = false;        
        });
        this.chunkQueue.push(answer);  // Push the chunk into the queue
        if (!this.isProcessingChunk) {
          this.processNextChunk(index);  // Start processing the next chunk if not already processing
        }
      }, () => {
      });
    } catch (error) {
      console.error('Error fetching response:', error);
      this.waitingForResponse = false;
      var error = 'Error communicating with the server.';
      this.messages.push({text: error, type: 'bot', doneProcessing: true});
    }
    this.userMessage = '';
    this.getTextareaRowCount();
    this.scrollToBottom();
  }

  reformatText(index) {
    var message = this.messages[index];
    var text = message.text;
      //text = text.replace(/<i><\/i>/g, '');
      text = text.replace(/\n/g, '');
      text = text.replace(/<h1>/g, '<h3>').replace(/<\/h1>/g, '</h3>');
      text = text.replace(/<h2>/g, '<h4>').replace(/<\/h2>/g, '</h4>');
      text = text.replace(/<code class="language-html">/g, '<code>') 
      text = text.replace(/```html/g, '<pre><code>')
      
      // replace with <pre><code></pre></code> when ``` and ``` at the end 
      text = text.replace(/```javascript/g, '<pre><code>')
      text = text.replace(/```/g, '</code></pre>');
      text = text.replace(/<code>([\s\S]*?)<\/code>/g, (_, codeContent) =>
          `<code>${codeContent
              .replace(/<br>/g, "\n")
              .replace(/</g, "&lt;")
              .replace(/>/g, "&gt;")
          }</code>`
        );  
      this.messages[index].text = text;

    this.checkForYOverflow();
    this.scrollToBottom();
  }

  extractExtras(index) {

    if (this.sourceURLs.length > 0) {
      var textToAdd = `<br/><br/><i>For additional information, <a href="${this.sourceURLs[0]}" target="_blank" rel="noopener noreferrer">read the full article here</a>.</i>`;

      // if (this.sourceURLs.length >= 2) {
      //   textToAdd += ` You might find <a href="${this.sourceURLs[1]}" target="_blank" rel="noopener noreferrer">this helpful too</a>`
      // }
      // else if (this.sourceURLs.length > 2) {
      //   textToAdd += ` You might find these helpful too: <ul class="pl-4"><li><a href="${this.sourceURLs[1].url}" target="_blank" rel="noopener noreferrer">${this.sourceURLs[1].title}</a></li><li><a href="${this.sourceURLs[2].url}" target="_blank" rel="noopener noreferrer">${this.sourceURLs[2].title}</a></li></ul>`
      // }

      //textToAdd += '</i>';

      // add character by character with delay
      let charIndex = 0;
      const addChar = () => {
        if (charIndex < textToAdd.length) {
          this.ngZone.run(() => {
            this.messages[index].text += textToAdd[charIndex];
            charIndex++;
            setTimeout(addChar, 5); // Adjust delay as needed
          });
        }
      };
      addChar();
    }

    this.checkForYOverflow();
    this.scrollToBottom();
  }

  // Function to process each chunk sequentially
  processNextChunk(index) {
    if (this.chunkQueue.length > 0) {
      this.isProcessingChunk = true;  // Set flag that we're processing a chunk
      const chunk = this.chunkQueue.shift(); // Get the next chunk in the queue

      if (!this.messages[index]) { // if no message exists at the index, create one
        this.messages[index] = { text: '<div>', type: 'bot', doneProcessing: false };
      }
      // Process the chunk one character at a time with typing effect
      this.processChunkSequentially(chunk, index);
    
    } else {
      this.messages[index].doneProcessing = true;
      this.isProcessingChunk = false;  // Reset flag when there are no more chunks
      this.reformatText(index);
      this.extractExtras(index);
    }
  }

  // Function to handle processing a chunk sequentially (character by character)
  processChunkSequentially(chunk: string, index: number) {
    let charIndex = 0;
    if (!this.messages[index].doneProcessing) { 
      const addChar = () => {
        if (charIndex < chunk.length) {
          this.ngZone.run(() => {
            this.messages[index].text += chunk[charIndex]; // Add one character at a time
            this.scrollToBottom();
          });
          charIndex++; // Move to the next character
          if (!this.messages[index].doneProcessing) setTimeout(addChar, 5); // Adjust delay for typing effect
          else {
            this.extrasFromResponse += chunk.slice(charIndex);
            charIndex = chunk.length;
            addChar();
          }
        } else {
          this.ngZone.run(() => {
            this.processNextChunk(index);  // Continue processing next chunk in queue
          });
        }
      };
  
      addChar();
    }
    else {
      this.extrasFromResponse += chunk;
      charIndex = chunk.length;
      this.ngZone.run(() => {
        this.processNextChunk(index);  // Continue processing next chunk in queue
      });
    }
  }

  scrollToBottom(): void {
    setTimeout(() => {
      this.chatBox.nativeElement.scrollTop = this.chatBox.nativeElement.scrollHeight;
    }, 100);
  }

  selectSuggestion(text) {
    this.sendMessage(text);
  }

  toggleChat() {
    this.showChat = !this.showChat;
    // this.nextQuestions = [
    //   "How does CleanID work?",
    //   "What are CleanID's main features?",
    //   "How can CleanID benefit market research projects project projects?",
    //   "Where can I learn more about CleanID?"
    // ]

    this.nextQuestions = [];
    this.userMessage = '';
    if (this.showChat) {
      this.addedEventListener = false;
      this.sessionId = uuidv4();
    }
    else {
      this.sessionId = null;
      this.messages = [];
      this.isOverflowing = false;
      this.waitingForResponse = false;
    }

    // setTimeout(() => {
    //   this.addMessage("<p>To use the CleanID API, follow these steps:</p><ol><li>Include the CleanID JavaScript file in your HTML page:</li><pre><code><script type=\"text/javascript\" data-nc id=\"cleanid_script_id\" src=\"https://idsuite.navigatorsurveys.com/cleanid-v3.current.min.js\" data-key=\"your_API_key_here\"></script></code></pre><li>Create event handler callbacks for success and failure:</li><pre><code><script type=\"text/javascript\">function successCallback(jsonObject) null function errorCallback(jsonObject) null</script></code></pre><li>Create the input parameters to pass to the API.</li><li>Call the CleanID API:</li><pre><code><script type=\"text/javascript\">IDSuite.cleanid({RequestId: \"Resp123\", PanelistId: null, EventId: \"P12345\", Event: \"CleanID Test Project\", ChannelId: \"1\", Channel: \"Partner A\", GeoRestrictionEnabled: true, Countries: [\"us\",\"gb\"], Status: \"Start\", DuplicateStatus: [\"Complete\", \"QC\"], DuplicateEvents: [{EventId:\"Wave1\", DuplicateStatus:[\"Complete\"]}, {EventId:\"Wave2\", DuplicateStatus:[\"Complete\"]}], onSuccess: successCallback, onError: errorCallback, FullDataSet: true});</script></code></pre><li>Process the response in the callback methods.</li></ol>", "bot");
    // }, 100);
  }

  handleEmptyInput(event: KeyboardEvent) {
    if (event.key === 'Enter') event.preventDefault();
    var text = this.userMessage.trim();
    if (text == '') {
      if (event.key === ' ') event.preventDefault();
      this.userMessage = '';
    }
  }

  checkForYOverflow() {
    // delay by 10ms to allow for DOM update
    setTimeout(() => {
      if (this.chatBox.nativeElement.scrollHeight > this.chatBox.nativeElement.clientHeight) {
        this.isOverflowing = true;
      } else {
        this.isOverflowing = false;
      }
    }, 10);
  }

  getTextareaRowCount() {
    // timeout to catch up with DOM update
    setTimeout(() => {
      const textarea = this.textArea.nativeElement;
      const lineHeight = parseInt(getComputedStyle(textarea).lineHeight, 10) || 20;

      // Reset height to auto to allow shrinkage
      textarea.style.overflowY = "hidden";
      textarea.style.height = 'auto';
      var scrollHeight = textarea.scrollHeight;
      // Set new height based on scrollHeight
      textarea.style.height = `${scrollHeight}px`;

      // Calculate row count
      var rowCount = (Math.round(scrollHeight / (lineHeight*10))) * 10;
      this.rowCount = rowCount;
  
      if (scrollHeight <= 78) {
        this.chatBoxHeight = 138;
      }
      else {
        this.chatBoxHeight = 145 + (scrollHeight-87);
      }
    }, 10);
    
  }
}
